import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=a3216648"
import script from "./SuppliersTable.vue?vue&type=script&lang=ts"
export * from "./SuppliersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports